module.exports = __webpack_public_path__ + "img/notestext.3bc70fae.webp";